import React from "react";
import Checkbox from "antd/lib/checkbox";
import Radio from "antd/lib/radio";
import {
  SurveyNoticeCard,
  SurveyQuestionCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface UrinarySymptomsSectionProps {
  readonly currentPage: number;
  setShowSubmit(show: boolean): void;
}

export const UrinarySymptomsSection: React.FC<UrinarySymptomsSectionProps> = ({
  currentPage,
  setShowSubmit
}) => {
  return (
    <>
      {currentPage === 1 && (
        <>
          <SurveyNoticeCard />
          <SurveyQuestionCard
            title="Do you want to report any urinary symptoms?"
            required
          >
            <FormItemStyle
              name="Report your urinary symptoms"
              label=""
              rules={[{ required: true }]}
              initialValue={""}
            >
              <Radio.Group
                value={localStorage.getItem("reportYourUrinarySymptoms")}
                onChange={e => {
                  if (e.target.value === "No") {
                    setShowSubmit(true);
                  } else {
                    setShowSubmit(false);
                  }
                  localStorage.setItem(
                    "reportYourUrinarySymptoms",
                    e.target.value
                  );
                }}
              >
                <AnswerList>
                  <AnswerOption value="Yes">Yes</AnswerOption>
                  <AnswerOption value="No">No</AnswerOption>
                </AnswerList>
              </Radio.Group>
            </FormItemStyle>
          </SurveyQuestionCard>
        </>
      )}

      {currentPage === 2 && (
        <SurveyQuestionCard
          sectionTag="URINARY SYMPTOMS"
          title="Do you have any of the following symptoms?"
        >
          <FormItemStyle name="Any urinary symptoms" label="" initialValue={""}>
            <Checkbox.Group
              style={{ width: "100%" }}
              onChange={e =>
                localStorage.setItem("anyUrinarySymptoms", e.toString())
              }
              value={sessionStorage.getItem("anyUrinarySymptoms")?.split(/,/)}
            >
              <AnswerList>
                <AnswerOption value="Urinating too frequently" isCheckbox>
                  Urinating too frequently
                </AnswerOption>
                <AnswerOption value="Needing to urinate urgently" isCheckbox>
                  Needing to urinate urgently
                </AnswerOption>
                <AnswerOption value="Incontinence of urine" isCheckbox>
                  Incontinence of urine
                </AnswerOption>
                <AnswerOption
                  value="Incomplete emptying of your bladder"
                  isCheckbox
                >
                  Incomplete emptying of your bladder
                </AnswerOption>
                <AnswerOption
                  value="Frequent urge to urinate small amounts"
                  isCheckbox
                >
                  Frequent urge to urinate small amounts
                </AnswerOption>
                <AnswerOption value="Poor urinary flow" isCheckbox>
                  Poor urinary flow
                </AnswerOption>
              </AnswerList>
            </Checkbox.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}

      {currentPage === 3 && (
        <SurveyQuestionCard
          sectionTag="Urinary Symptoms"
          title="Please indicate if you have any of the following symptoms (and contact your doctor)"
        >
          <div
            style={{
              color: "#d97706",
              fontWeight: 700,
              marginBottom: "12px",
              fontSize: "14px"
            }}
          >
            PLEASE CALL YOUR DOCTOR IF YOU HAVE ANY OF THE SYMPTOMS BELOW
          </div>
          <FormItemStyle
            name="Indicate urinary symptoms"
            label=""
            initialValue={""}
          >
            <Checkbox.Group
              style={{ width: "100%" }}
              onChange={e =>
                localStorage.setItem("indicateUrinarySymptoms", e.toString())
              }
              value={sessionStorage
                .getItem("indicateUrinarySymptoms")
                ?.split(/,/)}
            >
              <AnswerList>
                <AnswerOption value="Pain or burning with urination" isCheckbox>
                  Pain or burning with urination
                </AnswerOption>
                <AnswerOption value="Offensive urine odor" isCheckbox>
                  Offensive urine odor
                </AnswerOption>
                <AnswerOption value="Urine that appears cloudy" isCheckbox>
                  Urine that appears cloudy
                </AnswerOption>
                <AnswerOption value="Blood in urine" isCheckbox>
                  Blood in urine
                </AnswerOption>
              </AnswerList>
            </Checkbox.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}

      {currentPage === 4 && (
        <SurveyQuestionCard
          sectionTag="Urinary Symptoms"
          title="Please indicate if you have any of the following symptoms (and contact your doctor urgently)"
        >
          <div
            style={{
              color: "#e53935",
              fontWeight: 700,
              marginBottom: "12px",
              fontSize: "14px"
            }}
          >
            ** PLEASE BE SURE TO CALL YOUR DOCTOR OR SEEK EMERGENCY CARE IF YOU
            ARE REPORTING ANY SYMPTOMS BELOW **
          </div>
          <FormItemStyle
            name="Indicate urinary symptoms 2"
            label=""
            initialValue={""}
          >
            <Checkbox.Group
              style={{ width: "100%" }}
              onChange={e =>
                localStorage.setItem("indicateUrinarySymptoms2", e.toString())
              }
              value={sessionStorage
                .getItem("indicateUrinarySymptoms2")
                ?.split(/,/)}
            >
              <AnswerList>
                <AnswerOption value="Nausea/Vomitting" isCheckbox>
                  Nausea/Vomiting
                </AnswerOption>
                <AnswerOption value="Fever/Chills (more than 101F)" isCheckbox>
                  Fever/Chills (more than 101F)
                </AnswerOption>
                <AnswerOption value="Feeling unwell" isCheckbox>
                  Feeling unwell
                </AnswerOption>
                <AnswerOption value="Confusion/Disorientation" isCheckbox>
                  Confusion/Disorientation
                </AnswerOption>
              </AnswerList>
            </Checkbox.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
    </>
  );
};
